import { API_AUTH } from './common';

const StoreApi = {
  combo: ({ storeName = '', storeAddress = '', storeStatus = 1 }) =>
    API_AUTH.get(
      `quanlykho/danh-sach-kho-combo?storeName=${storeName}&storeAddress=${storeAddress}&storeStatus=${storeStatus}`,
      {}
    ),
  comboAll: ({ storeName = '', storeAddress = '' }) =>
    API_AUTH.get(
      `quanlykho/danh-sach-kho-combo-all?storeName=${storeName}&storeAddress=${storeAddress}`,
      {}
    ),
  post: ({ StoreName = '', StoreAddress = '', StoreStatus = 1, StoreId = 0 }) =>
    API_AUTH.post(`quanlykho/tao-sua-kho`, {
      StoreName,
      StoreAddress,
      StoreStatus,
      StoreId,
    }),
  delete: ({ Id }) => API_AUTH.delete(`quanlykho/xoa-kho?id=${Id}`, {}),
};

export default StoreApi;
